import { Button } from '../../components/ui/Button';
import { LogoMark } from '../../components/ui/Logo';
import { pageTitle } from '../../config/seo';
import { useSeo } from '../../hooks/useSeo';

export default function ErrorPage({ error }: { error?: unknown }) {
  useSeo({ title: pageTitle('Something went wrong'), noindex: true });
  const message = error instanceof Error ? error.message : undefined;
  return (
    <main className="flex min-h-screen flex-col items-center justify-center bg-bg-deep px-6 text-center">
      <LogoMark size={56} />
      <p className="mt-8 font-mono text-sm uppercase tracking-[0.3em] text-muted">Something broke</p>
      <h1 className="mt-3 text-4xl font-bold tracking-tight text-text">We hit an unexpected error.</h1>
      <p className="mt-3 max-w-md text-text-2">It has been reported. Reloading usually fixes it.</p>
      {message && <pre className="mt-4 max-w-lg overflow-auto rounded-control bg-surface p-3 text-left font-mono text-xs text-muted">{message}</pre>}
      <Button size="lg" className="mt-8" onClick={() => window.location.reload()}>
        Reload
      </Button>
    </main>
  );
}
